import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";

type ConfirmDeleteDialogProps = {
    open: boolean;
    title: string;
    message: string;
    onCancel: () => void;
    onDelete: () => void;
};

const ConfirmDeleteDialog = ({ open, title, message, onCancel, onDelete }: ConfirmDeleteDialogProps) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => setIsSaving(false), []);

    const onPerformDelete = () => {
        setIsSaving(true);
        onDelete();
    };

    return (
        <Dialog open={open} onClose={onCancel} fullWidth maxWidth={"sm"} fullScreen={fullScreen}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={isSaving}>
                    Cancel
                </Button>
                <Button variant="contained" color={"error"} onClick={onPerformDelete} disabled={isSaving}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
